<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big1">ELIZABETH ADLER</span></p>
<p class="center"><img alt="" src="OEBPS/images/9780312364496_L02.png"/></p>
<p class="center"><span class="big">O<span class="small1">NE</span> <em>Of</em> T<span class="small1">HOSE</span><br/>M<span class="small1">ALIBU</span> N<span class="small1">IGHTS</span></span></p>
<p class="left"><img alt="" src="OEBPS/images/9780312364496_001.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312364496_epub_tp_r1.vue?42c255fe